import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api/api.service';
import { CheckPointService } from '../check-point/check-point.service';
import { ShareData } from 'src/app/app.share-data';

@Injectable({
  providedIn: 'root'
})
export class PageNavigateService {

  mrpkBaseUrl = 'marketplace';
  contentID;

  constructor(
    private router: Router,
    private api: ApiService,
    private checkPoint: CheckPointService,
  ) { }

  navigate(service: any) {
    // console.log(service);
    if (!service.DisplayAsList && (service && service.ContentList && service.ContentList[0])) {
      this.contentID = service.ContentList[0].ContentID;
    } else if (service.ContentID) {
      this.contentID = service.ContentID;
    } else {
      this.contentID = service.PageID;
    }

    if (!this.contentID) {
      this.contentID = service.RefID;
    }

    if (!service.DisplayAsList && !this.contentID) {
      this.contentID = service.ContentID || service.ServiceID;
    }

    this.sendServiceLogs(service, service.ServiceType || 'Page', this.contentID);

    if ('ServiceType' in service && service.ServiceType) {
      this.navigateByServiceType(service);
    } else if ('ContentType' in service && service.ContentType) {
      this.navigateByContentType(service);
    } else {
      if ('WebURL' in service && service.WebURL) {
        this.setPathWithWebURL(service);
      } else if('RedirectPath' in service && service.RedirectPath) {
        this.setPathWithRedirectPath(service);
      } else {
        ShareData.currentMessage = service;
        this.navigateToPage(`notification-view/${service.MessageID}/${service.isToday}`, null);
      }
    }
  }

  sendServiceLogs(service: any, contentType: any, contentId: any, action: any = null) {
    this.api.sendServiceLogs(
      this.api.token as string
      , service.ServiceCode
      , contentType
      , contentId
      , action
    ).subscribe(res => {
      setTimeout(() => {
        this.checkPoint.checkPoint();
      }, 2000);
    }, err => {
      console.error('Send logs error: ', err);
    });
  }

  private navigateByServiceType(service: any) {
    let page = '';
    if (service.ServiceType.toLowerCase() === 'parent' || service.ServiceType.toLowerCase() === 'sub-parent') {
      page = `/services/${service.ServiceCode}`;
      this.navigateToPage(page);
    } else if (service.ServiceType.toLowerCase() === 'news') {
      page = `/news/${service.ServiceCode}`;
      if (!service.DisplayAsList) {
        page = `/news-detail/${service.NewsList[0].NewsID}`;
        this.navigateToPage(page);
        return;
      }
      this.navigateToPage(page, {page: 1});
    } else if (service.ServiceType.toLowerCase() === 'page') {
      page = `/content/${service.ServiceCode}`;
      if (!service.DisplayAsList) {
        page = `/content-detail/${service.ContentList[0].ContentID}`;
        this.navigateToPage(page);
        return;
      }
      this.navigateToPage(page, {page: 1});
    } else if (service.ServiceType.toLowerCase() === 'activity') {
      page = `/activity/${service.ServiceCode}`;
      if (!service.DisplayAsList) {
        page = `/activity-detail/${service.ActivityList[0].ActivityID}`;
        this.navigateToPage(page);
        return;
      }
      this.navigateToPage(page, {page: 1, tab: 1});
    } else if (service.ServiceType.toLowerCase() === 'reward') {
      page = '/reward';
      if('RefID' in service) {
        this.navigateToPage(page, {rewardId: service.RefID});
      } else {
        this.navigateToPage(page, {page: 1});
      }
    } else if (service.ServiceType.toLowerCase() === 'external') {
      this.setPathWithWebURL(service);
    } else if (service.ServiceType.toLowerCase() === 'link') {
      this.setPathWithWebURL(service);
    } else if (service.ServiceType.toLowerCase() === 'marketplace') {
        this.navigateToPage(`${this.mrpkBaseUrl}/home`);
    } else if (service.ServiceType.toLowerCase() === 'leaderboard') {
        this.navigateToPage(`points-leaderboard`);
    } else if (service.ServiceType.toLowerCase() === 'coursehistory' || service.ServiceType.toLowerCase() === 'course-history') {
        this.navigateToPage(`course-history`);
    } else if (service.ServiceType.toLowerCase() === 'mypoints' || service.ServiceType.toLowerCase() === 'my-points') {
        this.navigateToPage(`mypoints`);
    } else if (service.ServiceType.toLowerCase() === 'pointtransfer' || service.ServiceType.toLowerCase() === 'point-transfer') {
        this.navigateToPage(`point-transfer`);
    } else if (
      service.ServiceType.toLowerCase() === 'survey' ||
      service.ServiceType.toLowerCase() === 'servey' ||
      service.ServiceType.toLowerCase() === 'survey online' ||
      service.ServiceType.toLowerCase() === 'servey online'
    ) {
      page = '/survey';
      if (this.contentID) {
        this.navigateToPage(page, {id: this.contentID});
      } else {
        this.navigateToPage(page);
      }
    } else {
      if (service.URL && service.URL.indexOf('http') !== -1) {
        this.setPathWithWebURL(service);
      }
    }
  }

  private navigateByContentType(service: any) {
    let page = '';
    const contentKey = service.ReferentContentKey || service.ContentID || service.RefID;
    // console.log(service);

    if (service && service.ContentType === 'Activity') {
      page = `activity-detail/${contentKey}/1`;
      this.navigateToPage(page);
    } else if (service && service.ContentType === 'News') {
      page = `/news-detail/${contentKey}`;
      this.navigateToPage(page);
    } else if (service && service.ContentType === 'Page') {
      page = `/content-detail/${contentKey}`;
      this.navigateToPage(page);
    } else if (service && service.ContentType && service.ContentType.toLowerCase() === 'leaderboard') {
      page = `points-leaderboard`;
      this.navigateToPage(page);
    } else if (service && service.ContentType &&
               (service.ContentType.toLowerCase() === 'coursehistory' ||
                service.ContentType.toLowerCase() === 'course-history')) {
      page = `course-history`;
      this.navigateToPage(page);
    } else if (service && service.ContentType &&
               (service.ContentType.toLowerCase() === 'mypoints' ||
                service.ContentType.toLowerCase() === 'my-points')) {
      page = `mypoints`;
      this.navigateToPage(page);
    } else if (service && service.ContentType &&
               (service.ContentType.toLowerCase() === 'pointtransfer' ||
                service.ContentType.toLowerCase() === 'point-transfer')) {
      page = `point-transfer`;
      this.navigateToPage(page);
    } else if ('RedirectType' in service && service.RedirectType) {
      this.navigateByRedirectType(service);
    } else {
      if ('WebURL' in service && service.WebURL) {
        this.setPathWithWebURL(service);
      } else if ('RedirectPath' in service && service.RedirectPath) {
        this.setPathWithRedirectPath(service);
      }
    }
  }

  private navigateByRedirectType(service: any) {
    let page = '';
    if (service.RedirectType === 'REDIRECT_BROWSER') {
      if ('WebURL' in service && service.WebURL) {
        this.setPathWithWebURL(service);
      } else if ('RedirectPath' in service && service.RedirectPath) {
        this.setPathWithRedirectPath(service);
      }
    } else if (service.RedirectType === 'REDIRECT_EXTERNAL_APP') {
      if ('WebURL' in service && service.WebURL) {
        this.setPathWithWebURL(service);
      } else if ('RedirectPath' in service && service.RedirectPath) {
        this.setPathWithRedirectPath(service);
      }
    } else if (service.RedirectType === '0') {
      if (service && service.ContentType === 'MarketplaceInterestInfo') {
        page = `${this.mrpkBaseUrl}/detail`;
        this.router.navigate([page], { queryParams: {type: 3, product: service.ReferentContentKey}});
      } else if (service && service.ContentType === 'MarketplaceComment') {
        page = `${this.mrpkBaseUrl}/detail`;
        this.router.navigate([page], { queryParams: {type: 2, product: service.ReferentContentKey}});
      }
    }
  }

  public navigateToPage(page: any, q?: Object) {
    this.router.navigate([page], {queryParams: q});
  }

  private navigateToUrl(baseUrl: string){
    window.open(baseUrl, '_blank');
  }

  tryInternalNavigation(url: string): boolean {
    if (!url) return false;
    
    let path = url;
    const doubleSlashIndex = url.indexOf('//');
    if (doubleSlashIndex !== -1) {
      const nextSlashIndex = url.indexOf('/', doubleSlashIndex + 2);
      if (nextSlashIndex !== -1) {
        path = url.substring(nextSlashIndex);
      } else {
        path = '/';
      }
    }
    
    if (path.indexOf('/web/') === 0) {
      path = path.substring(4);
    } else if (path.indexOf('/web') === 0) {
      path = path.substring(4);
    }
    
    if (path.indexOf('/') !== 0) {
      path = '/' + path;
    }
    
    const internalRoutes = [
      '/news-detail',
      '/content-detail',
      '/activity-detail',
      '/points-leaderboard',
      '/course-history',
      '/mypoints',
      '/my-points',
      '/point-transfer',
      '/home',
      '/reward',
      '/marketplace',
      '/news',
      '/content',
      '/activity',
      '/profile',
      '/notification-view',
      '/notification-list',
      '/favorite-list'
    ];
    
    for (const route of internalRoutes) {
      if (path.indexOf(route + '?') === 0 || path === route || path.indexOf(route + '/') === 0) {
        this.router.navigateByUrl(path);
        return true;
      }
    }
    
    return false;
  }

  setPathWithWebURL(service: any){
    const url = service.WebURL || service.URL;
    if(!url) {
      console.error('Url is emty', service);
      return;
    }
    if (this.tryInternalNavigation(url)) {
      return;
    }
    if (url.indexOf('points-leaderboard') !== -1) {
      this.router.navigate(['/points-leaderboard']);
      return;
    }
    if (url.indexOf('course-history') !== -1) {
      this.router.navigate(['/course-history']);
      return;
    }
    if (url.indexOf('mypoints') !== -1 || url.indexOf('my-points') !== -1) {
      this.router.navigate(['/mypoints']);
      return;
    }
    if (url.indexOf('point-transfer') !== -1) {
      this.router.navigate(['/point-transfer']);
      return;
    }
    const webEndpointURL = (url.indexOf('cilacademy.com') !== -1) ? this.checkRedirect(url) : url;
    this.navigateToUrl(webEndpointURL);
  }

  setPathWithRedirectPath(service: any){
    const path = service.RedirectPath;
    if(!path) {
      return;
    }
    if (this.tryInternalNavigation(path)) {
      return;
    }
    if (path.indexOf('points-leaderboard') !== -1) {
      this.router.navigate(['/points-leaderboard']);
      return;
    }
    if (path.indexOf('course-history') !== -1) {
      this.router.navigate(['/course-history']);
      return;
    }
    if (path.indexOf('mypoints') !== -1 || path.indexOf('my-points') !== -1) {
      this.router.navigate(['/mypoints']);
      return;
    }
    if (path.indexOf('point-transfer') !== -1) {
      this.router.navigate(['/point-transfer']);
      return;
    }
    const webEndpointURL = (path.indexOf('cilacademy.com') !== -1) ? this.checkRedirect(path) : path;
    this.navigateToUrl(webEndpointURL);
  }

  checkRedirect(url: any) {
    // console.log(url.indexOf('course'));
    if(url.indexOf('authen?redirect=') !== -1) {
      url = `${url}&token=${this.api.token}&token_type=${this.api.tokenType}&type=${this.api.type}&access_token=${this.api.accessToken}`;
    } 
    else if(url.indexOf('course') !== -1) {
      url = url;
    }
    else if(
      url.indexOf('/web/') !== -1 ||
      url.indexOf('/web') !== -1 ||
      url.indexOf('news-detail') !== -1 ||
      url.indexOf('content-detail') !== -1 ||
      url.indexOf('activity-detail') !== -1 ||
      url.indexOf('mypoints') !== -1 ||
      url.indexOf('my-points') !== -1 ||
      url.indexOf('points-leaderboard') !== -1 ||
      url.indexOf('course-history') !== -1 ||
      url.indexOf('point-transfer') !== -1
    ) {
      url = url;
    }
     else {
      const separator = url.endsWith('/') ? '' : '/';
      url = `${url}${separator}authen?token=${this.api.token}&token_type=${this.api.tokenType}&type=${this.api.type}&access_token=${this.api.accessToken}`;
    }
    return url;
  }

  openNewTab(baseUrl: string){
    window.open(baseUrl, '_blank');
  }

  highlightOpenNewsList(service: any) {
    this.navigateToPage(`/news/${service.ServiceCode}`, {page: 1});
  }

  highlightOpenNews(service: any) {
    this.navigateToPage(`/news-detail/${service.ContentID || service.RefID}`);
  }

  highlightOpenPageList(service: any) {
    this.navigateToPage(`/content/${service.ServiceCode}`);
  }

  highlightOpenPage(service: any) {
    this.navigateToPage(`/content-detail/${service.ContentID || service.RefID}`);
  }

  highlightOpenRewardList(service?: any) {
    this.navigateToPage(`/reward`);
  }

  highlightOpenReward(service: any) {
    this.navigateToPage(`/reward`, {rewardId: service.RefID || service.RefID});
  }

  highlightOpenLink(service: any) {
    let url = service.WEB_URL || service.URL;
    if(!url) {
      console.error('Url is emty', service);
      return;
    }
    const webEndpointURL = (url.indexOf('cilacademy.com') !== -1) ? this.checkRedirect(url) : url;
    this.navigateToUrl(webEndpointURL);
  }

  highlightOpenActivity(service: any) {
    this.navigateToPage(`/activity/${service.ServiceCode}`);
  }

  highlightOpenActivityDetail(service: any) {
    this.navigateToPage(`/activity-detail/${service.ContentID || service.RefID}/1`);
  }

  highlightOpenParent(service: any) {
    this.navigateToPage(`/services/${service.ServiceCode}`);
  }

  highlighOpenMarketplace(service: any) {
    this.navigateToPage(`${this.mrpkBaseUrl}/home`);
  }

}
